export default "__VITE_ASSET__CNwhcwMe__"